<template>
    <div class="columns is-centered">
        <div class="column is-one-third">
            <h1 class="title">Account Settings</h1>
            <div class="bbbox">
                <p class="caption">Change Password</p>
                <b-field label="Enter your OLD password">
                    <b-input v-model="pwOld" type="password" icon-pack="mdi" password-reveal></b-input>
                </b-field>
                <b-field label="Enter your NEW password">
                    <b-input v-model="pw1" type="password" icon-pack="mdi" password-reveal></b-input>
                </b-field>
                <b-field label="To confirm, re-enter your new password">
                    <b-input v-model="pw2" type="password" icon-pack="mdi" password-reveal></b-input>
                </b-field>
                <p v-if="!isMatch" class="is-size-7">Passwords do not match. Please check.</p>
                <b-button :disabled="!isMatch || isLoading" @click="resetPassword">
                    <span v-if="isLoading">Please wait...</span>
                    <span v-else>Set new password</span>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import BField from "buefy/src/components/field/Field";
    import BInput from "buefy/src/components/input/Input";
    import BButton from "buefy/src/components/button/Button";
    export default {
        name: "MyAccount",
        components: {BButton, BInput, BField},
        data() {
            return {
                pwOld: null,
                pw1: null,
                pw2: null,
                isMatch: false,
                isLoading: false
            }
        },
        methods: {
            resetPassword() {
                const vm = this;
                if (vm.pw1 !== vm.pw2) {
                    alert("Warning: The two new passwords do not match. Please check and try again.")
                } else {
                    vm.isLoading = true;
                    vm.axios.post(`${vm.$host}/users/change-password?access_token=${localStorage.token}`, {
                        oldPassword: vm.pwOld,
                        newPassword: vm.pw2
                    })
                        .then(function (res) {
                            vm.isLoading = false;
                            alert("Password successfully changed!")
                        })
                        .catch(function (err) {
                            if (err.response.status === 401) {
                                alert("You were logged out when you tried to change your password. Please log in first with your OLD password.")
                                vm.$router.push({name: 'Login'});
                            } else {
                                alert(err)
                            }
                        })
                }
            }
        },
        watch: {
            pw2() {
                const vm = this;
                if (vm.pw1 === vm.pw2) {
                    vm.isMatch = true;
                } else {
                    vm.isMatch = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>